import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest, makePostRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import { toCompanyFormData } from './serializers'
import { serializeNullToEmptyString } from 'utils/helpers'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchCompanies() {
  try {
    const url = '/v1/companies'
    const rowData = yield makeGetRequest(url)
    yield put({
      type: ACT.COMPANIES_FETCH_SUCCESS,
      payload: {
        rowData: serializeNullToEmptyString(rowData.content)
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Opportunities',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* createCompany(action) {
  const { company, file } = action.payload
  try {
    const url = '/v1/companies'
    const response = yield makePostRequest(url, toCompanyFormData(company, file))

    yield put({
      type: ACT.COMPANY_CREATE_SUCCESS,
      payload: {
        company: response
      }
    })

    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'Company created successfully',
        level: 'success'
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue creating Company',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const companiesSagas = [
  takeLatest(ACT.COMPANIES_FETCH_REQUESTED, fetchCompanies),
  takeLatest(ACT.COMPANY_CREATE_REQUESTED, createCompany)
]

export default companiesSagas
